<template>
  <v-app>
    <AppBar></AppBar>
    <NavDrawer></NavDrawer>
    <!-- <v-navigation-drawer
      app
      clipped
      
    >
      <v-list>
        <v-list-item
          v-for="n in 5"
          :key="n"
          link
        >
          <v-list-item-content>
            <v-list-item-title>Item {{ n }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer> -->
    <v-main>
      <router-view></router-view>
    </v-main>
    <Appfooter></Appfooter>
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
import AppBar from "./components/AppBar";
import NavDrawer from "./components/NavDrawer";
import Appfooter from "./components/AppFooter";
export default {
  name: "App",
  components: {
    AppBar,
    NavDrawer,
    Appfooter,
  },
  data: () => ({}),

};
</script>
